import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import CallTypeSelect from "../../common/CallTypeSelect";
import ProjectSelect from "../../common/ProjectSelect";
import UserSelect from "../../common/UserSelect";

import ReportFilters from "../ReportFiltersComponent";

const TimeSummaryFilters = ({
  filters,
  onChange,
  fetchData,
  handleResetFilters,
  loading,
  exportDisabled,
  onCSVExport,
  onPDFExport
}) => {
  const { startDate, endDate } = filters; // yyyy/mm/dd
  const formattedStartDate = `${startDate.split("-")[1]}/${
    startDate.split("-")[2]
  }/${startDate.split("-")[0]}`;

  const formattedEndDate = `${endDate.split("-")[1]}/${endDate.split("-")[2]}/${
    endDate.split("-")[0]
  }`;

  return (
    <ReportFilters
      onFetchClick={fetchData}
      onResetClick={handleResetFilters}
      title={`Time Summary from ${formattedStartDate} to ${formattedEndDate}`}
      loading={loading}
      csvExportAvailable
      pdfExportAvailable
      onCSVExport={onCSVExport}
      onPDFExport={onPDFExport}
      exportDisabled={loading || exportDisabled}
      disabled={!startDate || !endDate || !filters.customers?.length}
    >
      <Row>
        <Col md={3}>
          <CustomerSelect
            label="Customer *"
            isLoading={loading}
            placeholder="Select"
            value={filters.customers || []}
            onChange={(e) => onChange("customers")(e || [])}
          />
        </Col>
        <Col md={3}>
          <ProjectSelect
            onChange={onChange("projects")}
            selectedCustomers={[filters.customers].flat() || []}
            placeholder="Select"
            label="Project"
            value={filters.projects || []}
          />
        </Col>
        <Col md={3}>
          <DepartmentSelect
            isMulti
            onChange={onChange("departments")}
            placeholder="Select"
            label="Department"
            value={filters.departments || []}
          />
        </Col>
        <Col md={3}>
          <CallTypeSelect
            isMulti
            onChange={onChange("callTypes")}
            placeholder="Select"
            label="Call Type"
            value={filters.callTypes || []}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <UserSelect
            isMulti
            onChange={(value) => onChange("users")(value.map((v) => v.value))}
            placeholder="Select"
            label="User"
            value={filters.users || []}
          />
        </Col>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            Start Date *
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            type="date"
            value={filters.startDate}
            onChange={(e) => onChange("startDate")(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            End Date *
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            type="date"
            value={filters.endDate}
            onChange={(e) => onChange("endDate")(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            * Required Fields
          </label>
        </Col>
      </Row>
    </ReportFilters>
  );
};
TimeSummaryFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  exportDisabled: PropTypes.bool,
  onCSVExport: PropTypes.func,
  onPDFExport: PropTypes.func
};
export default TimeSummaryFilters;
